import { render } from "./mainButton.vue?vue&type=template&id=ba023e12&scoped=true"
import script from "./mainButton.vue?vue&type=script&lang=js"
export * from "./mainButton.vue?vue&type=script&lang=js"

import "./mainButton.vue?vue&type=style&index=0&id=ba023e12&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba023e12"]])

export default __exports__